import { AuthClient } from "../data/auth-client";

async function GetUsersFromOrg() {
  try {
    const authClient = new AuthClient();

    const response = await authClient.getAllUsersFromOrg();

    return response;
  } catch (err) {
    console.error("Get Users from Org Status error", err);
    throw err;
  }
}

export default GetUsersFromOrg;
